export default {"src":"/_next/static/media/ic_skillz_horizontal_lockup.2af4f22b.svg","height":48,"width":199,"blurWidth":0,"blurHeight":0};